import { render, staticRenderFns } from "./DataBase.vue?vue&type=template&id=11dd17d2&scoped=true"
import script from "./DataBase.vue?vue&type=script&lang=js"
export * from "./DataBase.vue?vue&type=script&lang=js"
import style0 from "./DataBase.vue?vue&type=style&index=0&id=11dd17d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dd17d2",
  null
  
)

export default component.exports